import { render, staticRenderFns } from "./FooterCopyright.vue?vue&type=template&id=400521f2&"
var script = {}
import style0 from "./FooterCopyright.vue?vue&type=style&index=0&id=400521f2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports